import { codeBidiWarningMessages } from '@atlaskit/editor-common/messages';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { codeBidiWarningPluginKey } from '../plugin-key';
import { createBidiWarningsDecorationSetFromDoc, createPluginState, getPluginState } from './plugin-factory';
export var createPlugin = function createPlugin(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getIntl = _ref.getIntl;
  var appearance = _ref2.appearance;
  var intl = getIntl();
  var codeBidiWarningLabel = intl.formatMessage(codeBidiWarningMessages.label);
  return new SafePlugin({
    key: codeBidiWarningPluginKey,
    state: createPluginState(dispatch, function (state) {
      return {
        decorationSet: createBidiWarningsDecorationSetFromDoc({
          doc: state.doc,
          codeBidiWarningLabel: codeBidiWarningLabel,
          tooltipEnabled: true
        }),
        codeBidiWarningLabel: codeBidiWarningLabel,
        tooltipEnabled: true
      };
    }),
    props: {
      decorations: function decorations(state) {
        var _getPluginState = getPluginState(state),
          decorationSet = _getPluginState.decorationSet;
        return decorationSet;
      }
    }
  });
};